import axios from 'axios'

export default{
//  baseUrl : 'http://58.33.91.86:41115/',
 baseUrl: 'http://47.75.105.162:2900/',
//  baseUrl:'http://172.18.74.128:41115/',
    get (url, params) {
          return new Promise((resolve, reject) => {
            console.log(url)
            axios.get(this.baseUrl+url, {
              params: params
            }).then(res => {
              resolve(res.data)
            }).catch(err => {
              reject(err.data)
            })
          })
        }
      
}


// WEBPACK FOOTER //
// ./src/global/axios.js